<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body"><div class="block"><part-search-widget :component-type="componentType"></part-search-widget></div></div>
  </div>
</template>

<script>
import PartSearchWidget from './search/part-search-widget'
export default {
  name: 'PartList',
  components: {
    PartSearchWidget
  },
  computed: {
    pageTitle: function () {
      document.title = this.$t('part.list.title')
      return document.title
    }
  },
  data () {
    return {
      componentType: 'electronic_part'
    }
  }
}
</script>
